import React, {Dispatch, SetStateAction, useCallback} from 'react';

import {DateRangeInput} from 'src/components/input';

import ComboBox, {ComboboxItem, DefaultItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';

import type {EntitlementGrantLogsCriteria} from './typedef';
import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';


type Props = {
    actionTypeDictionary: DictionaryItem[],
    filter?: EntitlementGrantLogsCriteria,
    onChange?: Dispatch<SetStateAction<EntitlementGrantLogsCriteria>>,
};

export const LogFiltersBody = ({filter, onChange, actionTypeDictionary}: Props) => {
    const setStartDate = useCallback((date: string) => {
        if (onChange) {
            onChange(prev => {
                const {startDate: _startDate, ...rest} = prev;
                if (date) {
                    return {...rest, startDate: date};
                } else {
                    return rest;
                }
            });
        }
    }, [onChange]);

    const setEndDate = useCallback((date: string) => {
        if (onChange) {
            onChange(prev => {
                const {endDate: _endDate, ...rest} = prev;
                if (date) {
                    return {...rest, endDate: date};
                } else {
                    return rest;
                }
            });
        }
    }, [onChange]);

    const setActionType = useCallback((actionName: string) => {
        if (onChange) {
            onChange(prev => {
                const {actionName: _actionName, ...rest} = prev;
                if (actionName) {
                    return {...rest, actionName};
                } else {
                    return rest;
                }
            });
        }
    }, [onChange]);

    return (
        <Group direction="v" gap="s">
            <Label>Action Type</Label>
            <div style={{width: 270}}>
                <ComboBox value={filter?.actionName || ''} onChange={setActionType}>
                    <DefaultItem value="" key="all" caption="All"/>
                    {actionTypeDictionary.map(({code, description}) => (
                        <ComboboxItem key={code} value={code} caption={description}/>
                    ))}
                </ComboBox>
            </div>
            <Label>Period</Label>
            <DateRangeInput
                id="start-date-picker"
                width={270}
                label="Starts"
                clearable={true}
                startDate={filter?.startDate}
                endDate={filter?.endDate}
                preventFutureDate={true}
                selectRangeType="start"
                onChange={setStartDate}
            />
            <DateRangeInput
                id="end-date-picker"
                width={270}
                label={<>Ends&nbsp;&nbsp;</>}
                clearable={true}
                startDate={filter?.startDate}
                endDate={filter?.endDate}
                preventFutureDate={true}
                selectRangeType="end"
                onChange={setEndDate}
            />
        </Group>
    );
};
